import _ from 'lodash';
import { GOODIES } from '../constants';

export default function getGoodiesInCodebase(goodies) {
	return _.chain(goodies)
		.map(goody => GOODIES[goody])
		.filter(goody => !!goody)
		.value();
}



// WEBPACK FOOTER //
// ./src/selectors/getGoodiesInCodebase.js